import { useRef } from 'react'

import type { TransitionStatus } from 'react-transition-group'
import { SwitchTransition, Transition } from 'react-transition-group'
import { styled, css } from 'styled-components'

const transitionStyles: {
  [key in TransitionStatus]: ReturnType<typeof css>
} = {
  entering: css`
    opacity: 0;
    transform: translateY(100%);
    position: absolute;
  `,
  entered: css`
    opacity: 1;
    transform: translateY(0);
  `,
  exiting: css`
    opacity: 0;
    transform: translateY(-125%);
    position: absolute;
  `,
  exited: css`
    opacity: 0;
    transform: translateY(-125%);
    position: absolute;
  `,
  unmounted: [],
}

const TextContainer = styled.div<{
  $transitionState: TransitionStatus
}>`
  display: inline-block;

  transition:
    opacity 300ms ease,
    transform 300ms ease-in;

  ${({ $transitionState }) => transitionStyles[$transitionState]}
`

const TextTransition = ({
  transitionKey,
  children,
}: {
  transitionKey: string | number
  children: React.ReactNode
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  return (
    <SwitchTransition mode="in-out">
      <Transition key={transitionKey} timeout={300} nodeRef={containerRef}>
        {(state) => (
          <TextContainer ref={containerRef} $transitionState={state}>
            {children}
          </TextContainer>
        )}
      </Transition>
    </SwitchTransition>
  )
}

export default TextTransition
